import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { getBanners } from "../../api/app";

const SlideShow = (props) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    getBanners(props.type).then((response) => {
      setBanners(
        response.banners.map((item) => ({
          src: item.cover.uri,
          alt: item.name,
        }))
      );
    });

    return () => {
      setBanners([]);
    };
  }, []);

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      slidesPerView={1}
      loop={true}
      autoplay={{
        delay: 3000, // 3 seconds
        disableOnInteraction: false, // Keeps autoplay even after user interaction
      }}
      className="mb-5"
      style={{
        height: "100%",
        width: "100%",
        aspectRatio: "1280 × 299",
        borderRadius: "3rem",
      }}
    >
      {banners.map((item, index) => (
        <SwiperSlide key={index}>
          <a href="#">
            <div className="relative w-full h-full p-4 rounded-xl">
              <img
                src={item.src}
                alt={item.alt}
                className="object-cover w-full h-full rounded-xl"
              />
            </div>
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SlideShow;
